import { render, staticRenderFns } from "./JumpsellerOrderListComponent.vue?vue&type=template&id=7edb975a&scoped=true&"
import script from "./JumpsellerOrderListComponent.vue?vue&type=script&lang=js&"
export * from "./JumpsellerOrderListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edb975a",
  null
  
)

export default component.exports